/**
 * Norwegian currency formatting.
 *
 * The mockup renders amounts as "73 250 kr" (space as thousands separator,
 * "kr" suffix) and "73K" / "1,2M" in stat-tile contexts.
 */

const nbFormatter = new Intl.NumberFormat("nb-NO", {
  style: "currency",
  currency: "NOK",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const nbDecimalFormatter = new Intl.NumberFormat("nb-NO", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/** "73 250 kr" */
export const formatNOK = (amount: number): string => nbFormatter.format(amount);

/** "73 250" — plain integer, NOK grouping, no suffix */
export const formatInt = (n: number): string => nbDecimalFormatter.format(n);

/**
 * Short form for stat tiles. Norwegian decimal comma.
 *   1234       → "1,2K"
 *   73250      → "73K"
 *   1_234_567  → "1,2M"
 */
export const formatNOKShort = (amount: number): string => {
  const abs = Math.abs(amount);
  if (abs >= 1_000_000) return `${(amount / 1_000_000).toFixed(1).replace(".", ",")}M`;
  if (abs >= 10_000)    return `${Math.round(amount / 1000)}K`;
  if (abs >= 1_000)     return `${(amount / 1000).toFixed(1).replace(".", ",")}K`;
  return String(amount);
};

/** Chip stack formatting — same grouping, short "k" for inline contexts. */
export const formatChips = (chips: number): string => nbDecimalFormatter.format(chips);
export const formatChipsShort = (chips: number): string => {
  if (chips >= 1000) return `${(chips / 1000).toFixed(1).replace(".", ",")}k`;
  return String(chips);
};
